const CryptoJS = require('crypto-js');

const secretKey = 'xjfvZu6TKTV6NWww';
// Function to encrypt the URL parameter value
export function encryptUrlParam(value) {
  const encrypted = CryptoJS.AES.encrypt(value, secretKey).toString();
  // URL-encode the result to be safe for inclusion in a URL
  return encodeURIComponent(encrypted);
}

// Function to decrypt the URL parameter value
export function decryptUrlParam(encodedValue) {
  // URL-decode the value first
  const decodedValue = decodeURIComponent(encodedValue);
  const bytes = CryptoJS.AES.decrypt(decodedValue, secretKey);
  // Convert the decrypted bytes back to a string
  return bytes.toString(CryptoJS.enc.Utf8);
}
